import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import TextVariables from '../../../../classes/TextVariables';
import { SimulationStates } from '../../../../globals';

export default function Number(props)
{
	const style = {
		pointerEvents: props.pointerEvents ? props.pointerEvents : "none",
	}

	const simulationState = useSelector(state => state.applicationModule.simulationState, shallowEqual);

	const [value, setValue] = useState(props.prefill ? TextVariables.textToData(props.prefill) : '');

	useEffect(() =>
	{
		if(simulationState !== SimulationStates.Playing)
		{
			setValue(props.prefill ? TextVariables.textToData(props.prefill) : '');
		}
	}, [props.prefill]); 

	//render
	return (
		<input 
			type="number" 
			className={'checklistPreviewInputField'} 
			style={style} 
			value={value} 
			placeholder={'Add number'}
			onChange={(e)=>
			{
				setValue(e.target.value);
				if(props.onChangeCallback)
				{
					props.onChangeCallback(e.target.value);
				}
			}}/>
	)
}